/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import './MenuMobile.style';

import PropTypes from 'prop-types';
import {lazy, PureComponent, createRef } from 'react';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import CmsBlock from 'Component/CmsBlock';
import Link from 'Component/Link';
import MenuItem from 'Component/MenuItem';
import StoreSwitcher from 'Component/StoreSwitcher';
import CurrencySwitcher from 'Component/CurrencySwitcher';
import { MenuType } from 'Type/Menu';
import { getSortedItems } from 'Util/Menu'; 
import Html from "Component/Html";
import { isSignedIn } from 'Util/Auth';
import { appendWithStoreCode } from 'Util/Url';

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

/** @namespace Component/MenuMobile/Component */
export class MenuMobile extends PureComponent {
    static propTypes = {
        menu: MenuType.isRequired,
        activeMenuItemsStack: PropTypes.array.isRequired,
        handleSubcategoryClick: PropTypes.func.isRequired,
        closeMenu: PropTypes.func.isRequired,
        handleBurgerBackClick: PropTypes.func.isRequired,
        onCategoryHover: PropTypes.func.isRequired
    };

    cmsBlockRef = createRef();

    state = {
        activeCategorychilds: 0,
        cmsblockHeight: 0,
        loadedImagesCount: 0
    };

    setCmsBlockHeight = (current) => {
        if (current) {
          this.setState({ cmsblockHeight: current.clientHeight });
        }
      };
    
      changeHeightofCmsBlock = () => {
        const current = this.cmsBlockRef.current;
        const images = current?.querySelectorAll('img');
        const totalImages = images.length;
        const { loadedImagesCount } = this.state;
    
        const handleImageLoad = () => {
          this.setState((prevState) => ({
            loadedImagesCount: prevState.loadedImagesCount + 1,
          }));
    
          if (loadedImagesCount === totalImages) {
            this.setCmsBlockHeight(current);
          }
        };
    
        // Add an event listener to each image to trigger the load event.
        images.forEach((image) => {
          image.addEventListener('load', handleImageLoad);
        });
    
        // Clean up the event listeners when the component is unmounted.
        return () => {
          images.forEach((image) => {
            image.removeEventListener('load', handleImageLoad);
          });
        };
      };
    
      componentDidUpdate() {
        if (this.cmsBlockRef.current) {
          this.changeHeightofCmsBlock();
        }
      }
    

    renderDesktopSubLevelItems(item, mods) {
        const { item_id } = item;
        const { closeMenu, activeMenuItemsStack } = this.props;

        return (
            <MenuItem
                activeMenuItemsStack={ activeMenuItemsStack }
                item={ item }
                itemMods={ mods }
                closeMenu={ closeMenu }
                isLink
                key={ item_id }
            />
        );
    }

    renderDesktopSubLevel(category) {
        const { device } = this.props;
        const { children, item_class, item_id } = category;
        const childrenArray = getSortedItems(Object.values(children));

        if (device.isMobile || !childrenArray.length) {
            return null;
        }

        const isBanner = item_class === 'Menu-ItemFigure_type_banner';
        const isLogo = item_class === 'Menu-ItemFigure_type_logo';
        const mods = {
            isBanner: !!isBanner,
            isLogo: !!isLogo
        };

        return (
            <div
                block="Menu"
                elem="SubLevelDesktop"
                key={ item_id }
            >
                <div
                    block="Menu"
                    elem="ItemList"
                    mods={ { ...mods } }
                >
                    { childrenArray.map((item) => this.renderDesktopSubLevelItems(item, mods)) }
                </div>
            </div>
        );
    }

    renderSubLevelItems = (item,category) => {
        const {
            handleSubcategoryClick,
            activeMenuItemsStack,
            onCategoryHover,
            closeMenu,
            device
        } = this.props;

        const {
            item_id,
            children,
            item_class
        } = item;

        const isBanner = item_class === 'Menu-ItemFigure_type_banner';
        const childrenArray = Object.values(children);
        const subcategoryMods = { type: 'subcategory' };

        if (childrenArray.length && device.isMobile) {
            return (
                <div
                    key={ item_id }
                    // TODO: split into smaller components
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={ (e) => handleSubcategoryClick(e, item,category.title, category.url.pathname) }
                    tabIndex="0"
                    role="button"
                >
                    <MenuItem
                        activeMenuItemsStack={ activeMenuItemsStack }
                        item={ item }
                        itemMods={ subcategoryMods }
                        onCategoryHover={ onCategoryHover }
                        closeMenu={ closeMenu }
                    />
                    <UniversalIcon
                        src={media('icon_arrow_right_burger_menu.png', WYSIWYG_MEDIA)}
                        alt="arrowIcon"
                    />
                    { this.renderSubLevel(item) }
                </div>
            );
        }

        return (
            <MenuItem
                activeMenuItemsStack={ activeMenuItemsStack }
                item={ item }
                itemMods={ subcategoryMods }
                closeMenu={ closeMenu }
                isLink
            />
        );
    };

    renderSubLevel(category) {
        const { activeMenuItemsStack } = this.props;
        const { item_id, children, url, title } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };

        let cmsblockPromo = this.cmsBlockRef?.current;

        let cmsblockHeight = 0;

        if(cmsblockPromo) {
            cmsblockHeight = cmsblockPromo.clientHeight;
        }

        if(isVisible){
            this.setState({ activeCategorychilds : childrenArray.length });
            this.setState({ cmsblockHeight : cmsblockHeight });
        }

        return (
            <div
                block="Menu"
                elem="SubMenu"
                mods={ { isVisible } }
                key={ item_id }
            >
                <div
                    block="Menu"
                    elem="ItemList"
                    mods={ { ...subcategoryMods } }
                >
                    <Link
                        to={ url }
                        block="Menu"
                        elem="Link"
                    >
                        <figure className="Menu-ItemFigure Menu-ItemFigure_type_subcategory">
                            <figcaption className="Menu-ItemCaption Menu-ItemCaption_type_subcategory">{ __('See all products') }</figcaption>
                        </figure>
                    </Link>
                    {
                        childrenArray.map((child) => {
                            return this.renderSubLevelItems(child,category)
                        })}
                    { this.menuPromotionCms(category, isVisible) }
                </div>
            </div>
        );
    }

    renderPromotionCms() {
        const { closeMenu } = this.props;
        const { header_content: { header_cms } = {} } = window.contentConfiguration;

        if (header_cms) {
            return <CmsBlock identifier={ header_cms } />;
        }

        return (
            <div block="Menu" elem="Promotion">
                <h3 block="Menu" elem="PageLink">
                    <Link
                        to="/about-us"
                        onClick={ closeMenu }
                        block="Menu"
                        elem="Link"
                    >
                        { __('ABOUT US') }
                    </Link>
                </h3>
                <h3 block="Menu" elem="PageLink">
                    <Link
                        to="/about-us"
                        onClick={ closeMenu }
                        block="Menu"
                        elem="Link"
                    >
                        { __('CONTACTS') }
                    </Link>
                </h3>
                <div block="Menu" elem="Social">
                    <CmsBlock identifier="social-links" />
                </div>
            </div>
        );
    }

    renderSubMenuDesktopItems = (item) => {
        const { item_id, children } = item;

        if (!Object.keys(children).length) {
            return null;
        }

        const { activeMenuItemsStack, closeMenu } = this.props;
        const isVisible = activeMenuItemsStack.includes(item_id);

        if (!isVisible) {
            return null;
        }

        return (
            <div
                block="Menu"
                elem="SubCategoriesWrapper"
                mods={ { isVisible } }
                key={ item_id }
            >
                <div
                    block="Menu"
                    elem="SubCategoriesWrapperInner"
                    mods={ { isVisible } }
                >
                    <div
                        block="Menu"
                        elem="SubCategories"
                    >
                        { this.renderSubLevel(item) }
                    </div>
                    { this.renderAdditionalInformation() }
                </div>
                <div
                    block="Menu"
                    elem="Overlay"
                    mods={ { isVisible } }
                    onMouseEnter={ closeMenu }
                />
            </div>
        );
    };

    renderSubMenuDesktop(itemList) {
        const { device } = this.props;
        if (device.isMobile) {
            return null;
        }

        const childrenArray = getSortedItems(Object.values(itemList));

        return childrenArray.map(this.renderSubMenuDesktopItems);
    }

    renderAdditionalInformation(checkMobile = false) {
        const { device } = this.props;
        if (checkMobile && !device.isMobile) {
            return null;
        }

        return (
            <>
                { this.renderPromotionCms() }
            </>
        );
    }

    renderFirstLevelItems(item) {
        const {
            activeMenuItemsStack,
            handleSubcategoryClick,
            onCategoryHover,
            closeMenu,
            device
        } = this.props;

        const { children } = item;
        const childrenArray = Object.values(children);
        const itemMods = { type: 'main' };

        if (childrenArray.length && device.isMobile) {
            return (
                <div
                    // TODO: split into smaller components
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={ (e) => handleSubcategoryClick(e, item) }
                    tabIndex="0"
                    block="Menu"
                    elem="SubCatLink"
                    role="button"
                >
                    <MenuItem
                        activeMenuItemsStack={ activeMenuItemsStack }
                        item={ item }
                        itemMods={ itemMods }
                        onCategoryHover={ onCategoryHover }
                        closeMenu={ closeMenu }
                    />
                    <UniversalIcon
                        src={media('icon_arrow_right_burger_menu.png', WYSIWYG_MEDIA)}
                        alt="ArrowIcon"
                    />
                    { this.renderSubLevel(item) }
                </div>
            );
        }

        return (
            <MenuItem
                activeMenuItemsStack={ activeMenuItemsStack }
                item={ item }
                itemMods={ itemMods }
                onCategoryHover={ onCategoryHover }
                closeMenu={ closeMenu }
                isLink
            />
        );
    }

    renderFirstLevel = (item) => {
        const { item_id } = item;

        return (
            <li key={ item_id } block="Menu" elem="Item">
                { this.renderFirstLevelItems(item) }
            </li>
        );
    };

    renderTopLevel() {
        const { menu } = this.props;
        const categoryArray = Object.values(menu);

        if (!categoryArray.length) {
            return null;
        }

        const [{ children, title: mainCategoriesTitle }] = categoryArray;
        const childrenArray = getSortedItems(Object.values(children));

        return (
            <>
                <div block="Menu" elem="MainCategories">
                    <ul
                        block="Menu"
                        elem="ItemList"
                        mods={ { type: 'main' } }
                        aria-label={ mainCategoriesTitle }
                    >
                        { childrenArray.map(this.renderFirstLevel) }
                    </ul>
                </div>
            </>
        );
    }

    renderStoreSwitcher() {
        return <StoreSwitcher />;
    }

    renderCurrencySwitcher() {
        return <CurrencySwitcher />;
    }

    goBack(){
        const { handleBurgerBackClick } = this.props;
        let parentTitle  = this.props.parentTitle ;
        let parentUrl  = this.props.parentUrl ;
        let activeMenuItemsStack  = [...this.props.activeMenuItemsStack];
        let length = activeMenuItemsStack.length;
        parentTitle = length > 1 ? parentTitle : "";
        parentUrl = length > 1 ? parentUrl : "";
        if(length !== 0){
            activeMenuItemsStack.splice(0 , 1)
            handleBurgerBackClick(activeMenuItemsStack,parentTitle,parentUrl)
        }
    }


    renderBackButton(isVisible = false){

        return (
            <>
                <button
                    key="back"
                    block="Header"
                    elem="Button"
                    mods={ { type: 'back', isVisible } }
                    onClick={ this.goBack.bind(this) }
                    aria-label="Go back"
                    aria-hidden={ !isVisible }
                    tabIndex={ isVisible ? 0 : -1 }
                >
                    <UniversalIcon
                        src={media('icon_arrow_left_burger_menu.png', WYSIWYG_MEDIA)}
                        alt="goBackIcon"
                    />
                </button>
            </>
        );
    }

    renderBackButton(isVisible = false){

        return (
            <>
                <button
                    key="back"
                    block="Header"
                    elem="Button"
                    mods={ { type: 'back', isVisible } }
                    onClick={ this.goBack.bind(this) }
                    aria-label="Go back"
                    aria-hidden={ !isVisible }
                    tabIndex={ isVisible ? 0 : -1 }
                >
                    <UniversalIcon
                        src={media('icon_arrow_left_burger_menu.png', WYSIWYG_MEDIA)}
                        alt="goBackIcon"
                    />
                </button>
            </>
        );
    }

    renderCategoryTitle(isVisible = false){
        const {activeMenuTitle, activeMenuUrl, isFashionActive} = this.props;
        const title = isFashionActive ? 'HOME FASHION' : 'HOME BEAUTY';
        const url =  `${window.location.origin}${appendWithStoreCode(isFashionActive ? '/home_fashion' : '/')}`;

        if(!activeMenuTitle) {
            return (
            <div className="burger-current-category-title">
                <h1> 
                    <a href={ url } >
                        <span> { __( title ) } </span>
                    </a>
                </h1>
              </div>
            );
        }

        return <div className="burger-current-category-title active"><h1><span>{ activeMenuTitle }</span></h1></div>;
    }

    burgerBottom() {
        const {blocks} = this.props;
        if (blocks === undefined || blocks.items === undefined || blocks.items.attr_mobile_burger_bottom === undefined) {
            return null;
        }
        return  (
            <>
                <Html content={blocks.items.attr_mobile_burger_bottom.content}/>
            </>
        );
    }

    menuPromotionCms(item, isVisible) {
        const { url, megamenu_cms_block } = item;
        if (!megamenu_cms_block) {
            return null;
        }

        return (
            <div
                ref={ isVisible ? this.cmsBlockRef : null }
                className="Menu-Link-promos-cms"
                id={`Menu-Link-promos-cms-${isVisible ? 'isVisible' : ''}`}
            >
                <Html content={megamenu_cms_block} />
            </div>)
    }

    renderMenuClose() {
        return (
            <Link to="/" className="burger__close">
                <UniversalIcon
                    src={media('close.svg', WYSIWYG_MEDIA)}
                    alt="CloseIcon"
                />
            </Link>
        );
    }

    render() {
        const { closeMenu, activeMenuTitle, toggleMenu, isFashionActive } = this.props;
        let isVisible = this.props.activeMenuItemsStack.length === 0 ? false : true;
        let children = {};
        if(this.props.menu !== undefined && this.props.menu ){
            if(this.props.activeMenuItemsStack.length !== 0 && this.props.menu[Object.keys(this.props.menu).pop()].children !== undefined) {
                children = this.props.menu[Object.keys(this.props.menu).pop()].children;
                this.props.activeMenuItemsStack.map((item)=> {
                    if(
                        this.props.menu[Object.keys(this.props.menu).pop()].children[item] !== undefined
                        &&
                        this.props.menu[Object.keys(this.props.menu).pop()].children[item].children !== undefined
                    ){
                        children = children[item].children;
                    }
                });
            }
            else {
                let menuValues = Object.values(this.props.menu);
                if(menuValues.length)
                {
                    children = menuValues[0].children;
                }
            }
        }
        let childrenCount = Object.keys(children).length;
        let childrenHeight = 53;
        let mobileExtraHeight = 0;
        let showAdditionalItems = true;
        let cmsblockHeightMain = 0;

        if(activeMenuTitle && this.state.activeCategorychilds !== 0) {
            childrenCount = this.state.activeCategorychilds;
            mobileExtraHeight = 53;
            showAdditionalItems = false;
            if(this.props.activeMenuItemsStack.length === 1) {
                cmsblockHeightMain = this.state.cmsblockHeight;
            }
        }

        return (

            <div
                block="Menu"
                elem="MenuWrapper"
                onMouseLeave={ closeMenu }
            >
                { this.renderMenuClose() }
                <div className="burger__wrapper">
                    <div className="burger__container">
                        <div className="Header-WebsiteSwitch">
                            <div className="Header-WebsiteSwitchColumn">
                                <button
                                    block="Header"
                                    elem="WebsiteSwitchLink"
                                    mods={{ isActive: !isFashionActive }}
                                    onClick={toggleMenu}
                                ><span>{__('BEAUTY')}</span>
                                </button>
                            </div>
                            <div className="Header-WebsiteSwitchColumn">
                                <button
                                    block="Header"
                                    elem="WebsiteSwitchLink"
                                    mods={{ isActive: isFashionActive }}
                                    onClick={toggleMenu}
                                >
                                    <span>{__('FASHION')}</span>
                                </button>
                            </div>
                        </div>
                        <div className="burger-back-button">
                            { this.renderBackButton(isVisible) }
                        </div>
                        { this.renderCategoryTitle(isVisible) }
                        <div className="burger-menu" style={{ height : (childrenCount*childrenHeight)+mobileExtraHeight+ cmsblockHeightMain }}>
                            { this.renderTopLevel() }
                        </div>
                        { showAdditionalItems ?
                            <>
                                { this.burgerBottom() }
                                <div className="burger__items">
                                    <div className="burger__item burger__item_title">
                                        <strong>{ __('INFORMATION & HELP') }</strong>
                                    </div>
                                    <Link to={isSignedIn() ? "my-account/dashboard" : "/account/login" } className="burger__item">
                                        <span>{ __('Kαταστήματα') }</span>
                                    </Link>
                                    <Link to="/contact" className="burger__item">
                                        <span>{ __('Επικοινωνία') }</span>
                                    </Link>
                                    <Link to={ !isSignedIn() ? '/track-trace' : '/my-account/my-orders'} className="burger__item">
                                        <span>{ __('Βρες την παραγγελία σου') }</span>
                                    </Link>
                                    <Link to="/sychnes-erotiseis" className="burger__item">
                                        <span>{ __('Συχνές ερωτήσεις') }</span>
                                    </Link>
                                </div>
                                <div className="burger__items_account">
                                    <div className="burger__item_account burger__item_account_title">
                                        <strong>{ __( 'MY ACCOUNT') }</strong>
                                    </div>
                                    <Link to={isSignedIn() ? "/my-account/dashboard" : "/account/login" } className="burger__item_account">
                                        <div className="Image Image_ratio_square Image_imageStatus_1 Image_hasSrc">
                                            <UniversalIcon
                                                src={media('account_light.svg', WYSIWYG_MEDIA)}
                                                alt="AccountIcon"
                                                className="Image-Image"
                                            />
                                        </div>
                                        <span>{ __(isSignedIn() ? 'Dashboard' :'Σύνδεση / Εγγραφή') }</span>
                                    </Link>
                                    <Link to={!isSignedIn() ? "/guestwishlist" : "/my-account/my-wishlist" } className="burger__item_account">
                                        <div className="Image Image_ratio_square Image_imageStatus_1 Image_hasSrc">
                                            <UniversalIcon
                                                src={media('wishlist_light.svg', WYSIWYG_MEDIA)}
                                                alt="HeartIcon"
                                                className="Image-Image"
                                            />
                                        </div>
                                        <span>{ __('Wishlist') }</span>
                                    </Link>
                                    <div className="burger__item_account">
                                        { this.renderStoreSwitcher() }
                                    </div>
                                </div>
                                <div className="burger__logo">
                                    <UniversalIcon
                                        src={media('logo.svg', WYSIWYG_MEDIA)}
                                        alt="Logo"
                                    />
                                </div>
                            </>
                            : '' }
                    </div>
                </div>
            </div>

        );
    }
}

export default MenuMobile;
